<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
            <b-col sm="5" md="5" lg="2" xl="2" class="mb-md-0 mb-2">
                <b-form-group label="Tienda Origen" label-for="storeOrigin">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="locals"
                    label="name"
                    v-model="storeOrigin"
                    :reduce="(locals) => locals.id"
                    input-id="storeOrigin"
                    @input="filter"
                  />
                </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2" class="mb-md-0 mb-2">
                <b-form-group label="Tienda Destino" label-for="storeDestination">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="localsDestination"
                    label="name"
                    v-model="storeDestination"
                    :reduce="(localsDestination) => localsDestination.id"
                    input-id="storeDestination"
                    @input="filter"
                  />
                </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2">
              <b-form-group label="Documento" label-for="document">
                <b-form-input
                  id="document"
                  placeholder="N° Documento"
                  v-model="document"
                  trim
                  @input="filter"
                />
              </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2">
              <b-form-group label="Estado" label-for="state">
                <v-select
                  id="state"
                  :options="states"
                  v-model="state"
                  placeholder="Seleccione un Estado"
                  @input="filter"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                  class="mr-1"
                  @click.prevent="clean"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span class="align-middle">Limpiar</span>
                </b-button>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import StoresService from '@/services/StoresService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      codigo: '',
      arrayFilters: [],
      selectedLocal: null,
      locals: [],
      localsDestination: [],
      storeOrigin: null,
      storeDestination: null,
      document: '',
      userEstablishments: [],
      datosUser: null,
      state: null,
      states: ['Despachado', 'Cancelado', 'Registrado'],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  mounted() {
    this.getLocals()
    this.datosUser = JSON.parse(localStorage.getItem('userData'))
    this.userEstablishments = this.datosUser?.data?.userEstablishments || []
    this.userEstablishments = this.userEstablishments.map(establishment => establishment.id)
    console.log("my stablishments", this.userEstablishments)
  },
  methods: {
    async getLocals() {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const userEstablishments = userData?.data?.userEstablishments || [];

      this.locals = userEstablishments.map(est => ({
        id: est.id,
        name: est.name,
      }));

      this.localsDestination = [...this.locals];
    },
    filter() {
      this.arrayFilters = [];
      if (this.document !== '') {
        this.arrayFilters.push({
          keyContains: 'documentCode',
          key: 'contains',
          value: this.document
        })       
      }

      if (this.storeOrigin) {
        this.arrayFilters.push({
          keyContains: 'establishmentOriginId',
          key: 'equals',
          value: this.storeOrigin,
        });
      }/* else{
        console.log("entra else")
        this.arrayFilters.push({
          keyContains: 'establishmentOriginId',
          key: 'equals',
          value: this.userEstablishments.some,
        });
      } */

      if (this.storeDestination) {
        this.arrayFilters.push({
          keyContains: 'establishmentDestinyId',
          key: 'equals',
          value: this.storeDestination,
        });
      }

      if (this.state) {
        this.arrayFilters.push({
          keyContains: 'state',
          key: 'equals', 
          value: this.state,
        });
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.storeOrigin = null;
      this.storeDestination = null;
      this.document = '';
      this.state = null;
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>